import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@mui/material";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import type { WorkbookTemplate } from "../../../../../api/types/workbookRuns.types";

interface Props {
  isFetchingTemplates: boolean;
  templates: WorkbookTemplate[] | undefined;
  templateId: string;
  setTemplateId: (templateId: string) => void;
}

const WorkbookTemplateSelector = ({ isFetchingTemplates, templates, templateId, setTemplateId }: Props) => {
  const validTemplateId = templates?.some((t) => t.id === templateId) ? templateId : "";

  return (
    <FormControl fullWidth>
      <InputLabel id="template-select-label">Workbook Template</InputLabel>
      <Select
        fullWidth
        label="Workbook Template"
        value={validTemplateId}
        onChange={(e) => setTemplateId(e.target.value)}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <Typography color="secondary">Workbook Template</Typography>;
          }

          return templates?.find((t) => t.id === selected)?.name ?? "";
        }}
        MenuProps={{
          sx: {
            maxHeight: "36rem",
          },
        }}
      >
        {isFetchingTemplates ? (
          <Box sx={{ height: "18rem" }}>
            <InlineLoader />
          </Box>
        ) : (
          templates?.map((t) => (
            <MenuItem key={t.id} value={t.id}>
              {t.name}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default WorkbookTemplateSelector;
